/// <amd-module name="Build/Queue-Panel/PackageResourcePanel" />
import * as React from "react";
import { PackageResourceData } from "Build/Client/Contracts/DataProvider";
import * as Resources from "Build/Queue-Panel/Resources";
import { QueueBuildStore } from "Build/Queue-Panel/Stores/QueueBuild";
import { IVssPageContext } from "VSS/Platform/Context";
import { Panel } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";

export interface IPackageResourcePanelProps {
    pageContext: IVssPageContext;
    store: QueueBuildStore;
    resource: PackageResourceData;
    onUpdate(resource: PackageResourceData): void;
    onDismiss(): void;
}

interface IPackageResourcePanelState extends PackageResourceData {
}

export class PackageResourcePanel extends React.Component<IPackageResourcePanelProps, IPackageResourcePanelState> {
    constructor(props: IPackageResourcePanelProps) {
        super(props);
        const state = { ...props.resource, searchText: "" };
        this.state = state;
    }

    public render(): JSX.Element {
        return (
            <Panel
                backButtonProps={{ onClick: this.props.onDismiss }}
                contentClassName="queue-panel-child no-padding"
                description={Resources.PipelineResourcePanelDescription}
                escDismiss={true}
                onDismiss={this.props.onDismiss}
                titleProps={{ text: this.props.resource.name }}
                className="pipeline-resource-panel"
                footerButtonProps={[
                    {
                        text: Resources.CancelButtonText,
                        onClick: this.props.onDismiss
                    },
                    {
                        text: Resources.PipelineResourceUpdateButtonText,
                        primary: true,
                        onClick: this._update
                    }]}>
                <div className="margin-vertical-8 flex-grow">
                    {this._getTextField()}
                </div>
            </Panel>
        );
    }

    private _update = () => {
        const resource = { ...this.state };
        this.props.onUpdate(resource);
        this.props.onDismiss();
    }

    private _getTextField(): JSX.Element {
        return (
            <TextField
                placeholder={Resources.PackageResourceSearchBarText}
                className="margin-horizontal-20 margin-bottom-8"
                value={this.state.version}
                onChange={(e, value) => this.setState({ version: value })}
            >
            </TextField >
        )
    }
}

